import type { App } from 'vue';
import _each from 'lodash/each';
import _isFunction from 'lodash/isFunction';
const importPlugins = import.meta.glob('./*.ts', {
  eager: true,
  import: 'default',
});

export default function registerPlugins(app: App) {
  _each(importPlugins, registerFn => {
    if (_isFunction(registerFn)) {
      registerFn(app);
    }
  });

  return app;
}
